module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    staticClass: "ge-image-filter"
  }, [_c('filter', {
    attrs: {
      "id": "greenFilter",
      "color-interpolation-filters": "sRGB",
      "x": "0",
      "y": "0",
      "height": "100%",
      "width": "100%"
    }
  }, [_c('feColorMatrix', {
    attrs: {
      "type": "matrix",
      "values": "0.2207 0 0 0\t0.158\n\t\t\t\t0.58 0 0 0\t\t0.25\n\t\t\t\t0.28 0 0 0\t\t0.193\n\t\t\t\t0 \t 0 0 1\t\t0"
    }
  })], 1), _vm._v(" "), _c('filter', {
    attrs: {
      "id": "grayFilter",
      "color-interpolation-filters": "sRGB",
      "x": "0",
      "y": "0",
      "height": "100%",
      "width": "100%"
    }
  }, [_c('feColorMatrix', {
    attrs: {
      "type": "matrix",
      "values": "0.635 0 0 0\t\t0.158\n\t\t\t\t0.543 0 0 0\t\t0.25\n\t\t\t\t0.603 0 0 0\t\t0.193\n\t\t\t\t0 \t  0 0 1\t\t0"
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// F:/Solutions/6713ge/master/~/vue-loader/lib/template-compiler?{"id":"data-v-100dfdc8"}!F:/Solutions/6713ge/master/~/vue-loader/lib/selector.js?type=template&index=0!./scripts/ge-image-filter/ge-image-filter.vue
// module id = 341
// module chunks = 1